import { useCallback } from 'react';

import log from 'loglevel';

import {
  searchContacts as searchRemoteContacts,
  userContactToAddress,
} from '../services/contacts.service';
import { AddressSuggestion } from '../utils/addressSuggestion';

export const useEmailContacts = () => {
  const searchContacts = useCallback(
    async (query: string): Promise<AddressSuggestion[]> => {
      if (!query.trim()) {
        return [];
      }

      try {
        const remoteResults = await searchRemoteContacts({
          input: query,
          requireEmail: true,
        });
        return remoteResults
          .map(userContactToAddress)
          .filter((addr): addr is AddressSuggestion => addr !== null);
      } catch (error) {
        log.error('Remote contact search failed:', error);
        return [];
      }
    },
    [],
  );

  return {
    searchContacts,
  };
};
